package org.example.project.engineSnap

import androidx.compose.runtime.Composable
import org.example.project.dashboard.DashboardTheme
import org.example.project.dashboard.PopupEngineCard
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun SnapHintsContent(
    senderFirma: String,
    onClose: () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(14.px)
            padding(22.px)
            minHeight(100.percent)
            color(DashboardTheme.TEXT_LIGHT)
        }
    }) {
        Span({
            style {
                fontSize(20.px)
                fontWeight("700")
                textAlign("center")
                width(100.percent)
            }
        }) { Text("Vorteile der SNAP-Verbindung") }

        Div({ style { padding(8.px) } }) {}

        Span({
            style {
                fontSize(14.px)
                lineHeight("1.5")
                color(Color("rgba(247,247,245,0.82)"))
                textAlign("center")
                width(100.percent)
            }
        }) { Text("Welche Vorteile ergeben sich aus der Verbindung mit $senderFirma?") }

        Div({ style { padding(4.px) } }) {}

        BenefitItem("Dokumentenaustausch in Echtzeit")
        BenefitItem("Erweiterung deiner Kontaktliste im Netzwerk")
        BenefitItem("Einblick in Hofstatus und auftragsbezogene Informationen")
        BenefitItem("Direkte Einbindung in das Logistiknetzwerk")

        Div({
            style {
                marginTop(10.px)
                padding(16.px)
                borderRadius(10.px)
                backgroundColor(Color("rgba(255,255,255,0.04)"))
                textAlign("center")
                width(100.percent)
            }
        }) {
            Span({
                style {
                    fontSize(13.px)
                    lineHeight("1.45")
                    color(Color("rgba(247,247,245,0.72)"))
                }
            }) {
                Text("Wichtig: Alle Funktionen können jederzeit individuell aktiviert oder deaktiviert werden. Du behältst die volle Kontrolle über deine Verbindungen und Daten.")
            }
        }

        Div({
            style {
                display(DisplayStyle.Flex)
                marginTop(12.px)
            }
        }) {
            LumaticaButton(
                label = "Schließen",
                onClick = onClose,
                variant = LumaticaButtonVariant.Action
            )
        }
    }
}

@Composable
fun SnapBenefitsPopup(
    senderFirma: String,
    onConfirm: () -> Unit,
    onClose: () -> Unit
) {
    PopupEngineCard(
        windowKey = "snap-benefits-popup",
        widthPx = 620,
        heightPx = 460,
        minWidthPx = 560,
        minHeightPx = 420,
        viewportAnchored = true,
        onClose = onClose
    ) {
        Div({
            style {
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(14.px)
                padding(20.px)
                minHeight(100.percent)
                color(DashboardTheme.TEXT_LIGHT)
            }
        }) {
            Span({
                style {
                    fontSize(20.px)
                    fontWeight("700")
                }
            }) { Text("Vorteile der Snap-Verbindung") }

            Span({
                style {
                    fontSize(14.px)
                    lineHeight("1.5")
                    color(Color("rgba(247,247,245,0.82)"))
                }
            }) { Text("Welche Vorteile ergeben sich aus der Verbindung mit $senderFirma?") }

            BenefitItem("Dokumentenaustausch in Echtzeit")
            BenefitItem("Erweiterung deiner Kontaktliste im Netzwerk")
            BenefitItem("Einblick in Hofstatus und auftragsbezogene Informationen")
            BenefitItem("Direkte Einbindung in das Logistiknetzwerk")

            Div({
                style {
                    marginTop(6.px)
                    padding(12.px)
                    borderRadius(10.px)
                    backgroundColor(Color("rgba(255,255,255,0.04)"))
                }
            }) {
                Span({
                    style {
                        fontSize(13.px)
                        lineHeight("1.45")
                        color(Color("rgba(247,247,245,0.72)"))
                    }
                }) {
                    Text("Wichtig: Alle Funktionen können jederzeit individuell aktiviert oder deaktiviert werden. Du behältst die volle Kontrolle über deine Verbindungen und Daten.")
                }
            }

            Div({
                style {
                    display(DisplayStyle.Flex)
                    gap(12.px)
                    marginTop(10.px)
                }
            }) {
                LumaticaButton(
                    label = "Schließen",
                    onClick = onConfirm,
                    variant = LumaticaButtonVariant.Action
                )
            }
        }
    }
}

@Composable
private fun BenefitItem(text: String) {
    Div({
        style {
            display(DisplayStyle.Flex)
            gap(8.px)
        }
    }) {
        Span({
            style {
                fontSize(14.px)
                color(DashboardTheme.TEXT_LIGHT)
            }
        }) { Text("•") }
        Span({
            style {
                fontSize(14.px)
                color(Color("rgba(247,247,245,0.82)"))
                lineHeight("1.4")
            }
        }) { Text(text) }
    }
}
